import { ColorPicker, Upload, Typography, Modal, Row, Col, Button, DatePicker, Popconfirm, Popover, Input, Select, Checkbox, Switch } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import JoditEditor from "jodit-react";
import axios from 'axios';
import dayjs from 'dayjs';
import AdminModal from "./AdminModal";
const { Title, Paragraph, Text, Link } = Typography;
const { TextArea } = Input;
const { confirm } = Modal;

const ClassIntroduceModal = (props) => {
    const [more_information, set_more_information] = useState(false);
    const editor = useRef(null);
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        uploader: {
            insertImageAsBase64URI: true,
            // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        },
        language: 'zh_tw'
    };
    const [check, setCheck] = useState(false);
    const [schedule_date, set_schedule_date] = useState(undefined);
    const [data, setData] = useState([]);
    const [teachers, setTeachers] = useState('');
    const [blog_id, set_blog_id] = useState(null);
    useEffect(() => {
        axios
            .get('/cramSchool/api/lesson_category')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['lesson_category_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                setData(data_tmp)

            })
    }, [])
    useEffect(() => {
        // console.log(props.editcard);

        if (props.editcard['annoucement_time'] != undefined) {
            setCheck(true)
            set_schedule_date(props.editcard['annoucement_time']);
        } else {
            set_schedule_date(null);
        }
        if (JSON.stringify(props.editcard) != '{}' && props.editcard.teachers != undefined && props.editcard.teachers.length != 0) {
            let teacher = '';
            props.editcard.teachers && props.editcard.teachers.map((value, i) => {
                value.teachers.length != 0 && value.teachers.map((tmp) => {
                    teacher += `${tmp.teacher_name}、`
                })
                teacher = teacher.slice(0, -1);
            })
            setTeachers(teacher);
        } else {
            setTeachers('')
        }
        if (JSON.stringify(props.editcard) != '{}') {
            set_blog_id(props.editcard.blog_id);
        } else {
            set_blog_id('');

        }
    }, [props.editcard])
    useEffect(() => {
        set_more_information(false);
        if (props.editcard['more_content'] != null || undefined || "") {
            set_more_information(true);
        }
    }, [props.editcard['more_content']])
    const handleOnChange = (id) => {
        axios
            .get('/cramSchool/api/lesson_category', { params: { "lesson_category_id": id } })
            .then((response) => {
                let teacher = response.data[0].teachers.replace('{', "").replace('}', "").replace(",", "、");
                setTeachers(teacher);
            })
    }
    const handleOnChangeTop = (e) => {
        // console.log(e.target.checked);
        props.setEditCard(prev => {
            return (
                {
                    ...prev,
                    top: e.target.checked,
                }
            )
        })
    }
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >{props.title}</Col>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >課程分類</Col>
                    <Col>
                        {props.edit ?
                            <>
                                <Popconfirm
                                    placement="topRight"
                                    title='確定刪除嗎？'
                                    onConfirm={e => props.handleDelete(props.editcard['blog_id'])}
                                    okText="確定"
                                    cancelText="取消"
                                >
                                    <Button style={{ backgroundColor: '#FCF5F6' }} >
                                        <Row>
                                            <Col span={6}>
                                                <img width="80%" src='/cram_school/trashicon.png'></img>
                                            </Col>
                                            <Col span={18}>
                                                <span>刪除貼文</span>
                                            </Col>
                                        </Row>
                                    </Button>
                                </Popconfirm>
                            </> :
                            <>
                            </>
                        }
                    </Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={8}>課程分類名稱</Col>
                    <Col span={16}>
                        <Select
                            style={{
                                width: 200,
                            }}
                            labelInValue
                            options={data}
                            placeholder='請選擇課程名稱'
                            value={props.editcard['title']}
                            onChange={(value) => {
                                props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            title: value['label'],
                                            lesson_category_id: value['key'],
                                        }
                                    )
                                }); handleOnChange(value['key'])
                            }}>
                        </Select>
                    </Col>
                    <Col span={8}></Col>
                    <Col span={16}>
                        <Checkbox checked={props.editcard?.order_stage_id != 2 ? true : false} onChange={e =>
                            e.target.checked == true ?
                                props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            order_stage_id: 1,
                                        }
                                    )
                                }) :
                                props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            order_stage_id: 2,
                                        }
                                    )
                                })}> 顯示課程</Checkbox>
                    </Col>
                    <Col span={8}></Col>
                    <Col span={16}>
                        <Checkbox checked={check} onChange={e => setCheck(!check)}>排程發佈</Checkbox>
                        {check || props.editcard['annoucement_time'] != undefined ?
                            <DatePicker
                                // value={props.editcard['annoucement_time'] != undefined ? dayjs(null) : dayjs(schedule_date, 'YYYY-MM-DD')}
                                value={schedule_date == undefined ? undefined : dayjs(schedule_date, 'YYYY-MM-DD')}
                                onChange={(date, dateString) => props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            annoucement_time: dateString,
                                        }
                                    )
                                })} />
                            : null
                        }
                    </Col>
                    <Col span={8}></Col>
                    <Col span={16}>
                        <Checkbox checked={props.editcard?.top} onChange={handleOnChangeTop}>文章置頂</Checkbox>
                    </Col>
                    <Col span={8}>課程分類說明</Col>
                    <Col span={16}>
                        <TextArea rows={4} placeholder="請輸入課程分類說明" value={props.editcard['content']}
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        content: e.target.value,
                                    }
                                )
                            })} />
                    </Col>
                    <Col span={8}></Col>
                    <Col span={16}>
                        <Checkbox checked={more_information} onChange={e => set_more_information(!more_information)}>更多內容</Checkbox>
                    </Col>
                    {
                        more_information ? <>
                            <JoditEditor
                                ref={editor}
                                value={props.editcard.more_content}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                onBlur={value => props.setEditCard(prev => {
                                    return (
                                        {
                                            ...prev,
                                            more_content: value
                                        }
                                    )
                                })}
                                height={500}
                                allowResizeX={true}
                                allowResizeY={true}
                            />
                        </> : null
                    }
                    <Col span={6}>授課老師</Col>
                    <Col span={18}>
                        <label>{teachers}</label>
                    </Col>
                    <Col span={6}>
                        招生狀態
                    </Col>
                    <Col span={18}>
                        <Switch checked={props.editcard['enroll_status'] == 1 ? true : false}
                            disabled
                        // onChange={e => {
                        //     e == false ?
                        //         props.setEditCard(prev => {
                        //             return (
                        //                 {
                        //                     ...prev,
                        //                     enroll_status: 0
                        //                 }
                        //             )
                        //         }) :
                        //         props.setEditCard(prev => {
                        //             return (
                        //                 {
                        //                     ...prev,
                        //                     enroll_status: 0
                        //                 }
                        //             )
                        //         })
                        // }}
                        />
                    </Col>
                    {props.editcard['enroll_status'] == 1 ?
                        <>
                            <Col span={8}>招生圖片顏色</Col>
                            <Col span={16}>
                                <ColorPicker
                                    format={'hex'}
                                    value={props.editcard.enroll_status_background_color}
                                    onChange={color =>
                                        props.setEditCard((pre) => {
                                            return (
                                                {
                                                    ...pre,
                                                    enroll_status_background_color: `#${color.metaColor.toHex()}`,
                                                }
                                            )
                                        })
                                    }></ColorPicker>
                            </Col>
                            <Col span={8}>招生文字顏色</Col>
                            <Col span={16}>
                                <ColorPicker
                                    format={'hex'}
                                    value={props.editcard.enroll_status_font_color}
                                    onChange={color =>
                                        props.setEditCard((pre) => {
                                            return (
                                                {
                                                    ...pre,
                                                    enroll_status_font_color: `#${color.metaColor.toHex()}`,
                                                }
                                            )
                                        })
                                    }></ColorPicker>
                            </Col>
                        </> : null}
                    <Col span={6}>背景顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.background_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            background_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                    <Col span={6}>文字顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.font_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            font_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                    <Col span={8}>照片背景顏色</Col>
                    <Col span={16}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.pic_background_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            pic_background_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                </Row>
            </AdminModal >
        </>
    )
}
export default ClassIntroduceModal;